<!--Copy right - © 2024 tecera gmbh-->
<script>
    import DropDownButton from "./buttons/DropDownButton.svelte";
    export let device_list;
    export let search_input = "";
    export let loading;
    import { customer_list } from "../stores.js";
    import VisibilityDropdown from "./buttons/VisibilityDropdown.svelte";
</script>

{#await loading}
    <div id="loader" class="loader" />
{:then}
    <table class="table table-striped table-sm" id="data_table">
        <thead id="data_table_head">
            <tr>
                <th scope="col" style="width: 30%;">Gerät (DevEUI)</th>
                <th scope="col" style="width: 20%; text-align: center;"
                    >Status</th
                >
                <th scope="col" style="width: 20%; text-align: center;"
                    >Besitzer</th
                >
                <th scope="col" style="width: 30%; text-align: center;"
                    >erweiterte Sichtbarkeit</th
                >
            </tr>
        </thead>

        <tbody id="customer_table_body">
            {#each device_list as device}
                {#if device.dev_eui
                    .toLowerCase()
                    .includes(search_input
                            .toLowerCase()
                            .trim()) || (device.sub_id ? device.sub_id
                              .toLowerCase()
                              .includes(search_input
                                      .toLowerCase()
                                      .trim()) : false)}
                    <tr
                        ><th style="vertical-align: middle;">
                            {#if !device.sub_id}
                                {device.dev_eui}
                            {:else}
                                {device.dev_eui} - {device.sub_id}
                            {/if}</th
                        >
                        <td style="text-align: center;vertical-align:middle;"
                            >{device.status === "active"
                                ? "aktiv"
                                : "inaktiv"}</td
                        >
                        <td style="text-align: center;vertical-align:middle;"
                            >{device.customer.name}</td
                        >
                        <!-- <td
                            >
                            <div class="input-group mb-2 mt-2">
                                <DropDownButton
                                    options={$customer_list}
                                    bind:selected_option={device.customer}
                                />
                            </div>
                          
                            </td
                        > -->
                        <td
                            ><div class="input-group mb-2 mt-2">
                                <VisibilityDropdown bind:device_customers={device.device_customers} bind:owner_id={device.customer.id}/>
                            </div></td
                        >

                        <!-- <td
                            ><div>
                                <button
                                    on:click={() => {
                                        device = null;
                                    }}
                                    type="button"
                                    class="primary-color btn btn-normal btn-transparent btn-block pt-2"
                                    ><i class="fa fa-trash-can"></i></button
                                >
                            </div></td>--></tr
                    >
                {/if}
            {/each}
        </tbody>
    </table>
{/await}
